document.addEventListener('DOMContentLoaded', () => {
  // show success message
  if (!!window.location.search.slice(1).match('applicant=success')) {
    window.present('quick_apply_success_modal');

    const url = new URL(window.location);
    url.searchParams.delete('applicant');
    history.replaceState(null, '', url);
  }

  if (!!window.location.search.slice(1).match('contact_form=success')) {
    window.present('contact_form_success_modal');

    const url = new URL(window.location);
    url.searchParams.delete('contact_form');
    history.replaceState(null, '', url);
  }

  // show remote modal
  if (!!document.getElementById('position-modal-quick-apply_form')) {
    initOpenPositionModal('position-modal-quick-apply');
  }

  function initOpenPositionModal(namespace) {
    const applyForm = document.getElementById(`${namespace}_form`);
    const resumeButton = document.getElementById(`${namespace}_resume-button`);
    const applicationFileField = document.getElementById(`${namespace}_file-field`);
    const buttonFilenameLabel = document.getElementById(`${namespace}_file-field-label`);
    const filenameCancelUpload = document.getElementById(`${namespace}_cancel-upload`);
    const resumeDataFields = document.getElementById(`${namespace}_resume_data_fields`);
    const submitButton = document.getElementById(`${namespace}_submit-button`);

    const applyFormInputs = Array.from(applyForm.querySelectorAll('[data-required="true"]'));
    const resumeDataFieldInputs = Array.from(resumeDataFields.querySelectorAll('.x-resume-data'));

    function validateForm() {
      const missingRequiredInfo = applyFormInputs.filter(i => i.value === '').length > 0;
      const phoneRegex = RegExp(/\(\d{3}\) \d{3}-\d{4}/);
      const emailRegex = RegExp(/.*@.*\..{2,}/);

      const phone = document.getElementById(`${namespace}_wrenchway_applicant_lead_phone_number`);
      const badPhoneNumberFormat = !phoneRegex.test(phone.value);

      const email = document.getElementById(`${namespace}_wrenchway_applicant_lead_email`);
      const badEmailFormat = !emailRegex.test(email.value);

      const resume = document.getElementById(`${namespace}_file-field`);
      const resumeData = resumeDataFields.querySelectorAll('.x-resume-data');
      const missingResume = resumeDataFields.classList.contains('hidden') ? resume.value === '' : Array.from(resumeData).filter(i => i.value === '').length > 0;

      submitButton.disabled = missingRequiredInfo || badPhoneNumberFormat || badEmailFormat || missingResume;
    }

    // https://stackoverflow.com/a/29335409
    applyForm.querySelector('[data-format="phone"]').addEventListener('input', e => {
      const x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });

    // handle inputs
    for (let i = 0; i < applyFormInputs.length; i++) {
      applyFormInputs[i].addEventListener('input', validateForm);
    }
    for (let i = 0; i < resumeDataFieldInputs.length; i++) {
      resumeDataFieldInputs[i].addEventListener('input', () => {
        if (!resumeDataFields.classList.contains('hidden')) validateForm();
      });
    }

    // handle activate resume upload
    resumeButton.addEventListener('click', (e) => {
      e.preventDefault();
      applicationFileField.click();
    });

    // handle resume upload
    applicationFileField.addEventListener('input', () => {
      const file = applicationFileField.files[0];
      buttonFilenameLabel.innerHTML = file.name
      filenameCancelUpload.classList.remove('hidden');
      resumeButton.disabled = true;

      const orDivider = document.getElementById(`${namespace}_or_divider`);
      const provideAdditionalInfoButton = document.getElementById(`${namespace}_provide_additional_info_button`);
      const resumeDataFields = document.getElementById(`${namespace}_resume_data_fields`);

      orDivider.classList.remove('basis-full');

      orDivider.classList.add('hidden');
      provideAdditionalInfoButton.classList.add('hidden');
      resumeDataFields.classList.add('hidden');

      validateForm();
    });

    // handle resume upload cancel
    filenameCancelUpload.addEventListener('click', () => {
      applicationFileField.value = '';
      buttonFilenameLabel.innerHTML = '';
      filenameCancelUpload.classList.add('hidden');
      resumeButton.disabled = false;

      const orDivider = document.getElementById(`${namespace}_or_divider`);
      const provideAdditionalInfoButton = document.getElementById(`${namespace}_provide_additional_info_button`);
      const resumeDataFields = document.getElementById(`${namespace}_resume_data_fields`);

      orDivider.classList.remove('basis-full');

      orDivider.classList.remove('hidden');
      provideAdditionalInfoButton.classList.remove('hidden');
      resumeDataFields.classList.add('hidden');

      validateForm();
    });

    const clientId = '6LdvQeQUAAAAAFOAJM9ouTK4z0dXzgemXTvqdy8I';
    applyForm.addEventListener('submit', (event) => {
      event.preventDefault();
      grecaptcha
        .execute(clientId, { action: (namespace === 'quick-apply') ? 'submit_quick_apply' : 'submit_position_quick_apply' })
        .then((token) => {
          document.getElementById(`g-recaptcha-response-${namespace}`).value = token;
          applyForm.submit();
        })
    });
  };

  if (document.body.classList.contains('shops')) { initOpenPositionModal('quick-apply'); }
  window.initOpenPositionModal = initOpenPositionModal;
});
